<template>
  <div>
    <el-tabs
      v-model="activeName"
      type="card"
    >
      <el-tab-pane
        label="当日套利订货汇总"
        name="arbitrageOrderInquiry"
      >
        <arbitrageOrderInquiry />
      </el-tab-pane>
      <el-tab-pane
        label="当日套利订货明细"
        name="arbitrageOrderDetailInquiry"
      >
        <arbitrageOrderDetailInquiry />
      </el-tab-pane>
      <el-tab-pane
        label="历史套利订货汇总"
        name="historicalArbitrageOrderInquiry"
      >
        <historicalArbitrageOrderInquiry />
      </el-tab-pane>
      <el-tab-pane
        label="历史套利订货明细"
        name="historicalArbitrageOrderDetailInquiry"
      >
        <historicalArbitrageOrderDetailInquiry />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import arbitrageOrderInquiry from './arbitrage-order-inquiry'
import arbitrageOrderDetailInquiry from './arbitrage-order-detail-inquiry'
import historicalArbitrageOrderInquiry from './historical-arbitrage-order-inquiry'
import historicalArbitrageOrderDetailInquiry from './historical-arbitrage-order-detail-inquiry'
export default {
  name: 'Index',
  components: {
    arbitrageOrderInquiry,
    arbitrageOrderDetailInquiry,
    historicalArbitrageOrderInquiry,
    historicalArbitrageOrderDetailInquiry
  },
  data () {
    return {
      activeName: 'arbitrageOrderInquiry',
    }
  }
}

</script>
